import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
export const ChipPick = forwardRef(function ChipPick({ selected = false, className, children, ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: "button", "aria-pressed": selected, ...rest, className: cn('inline-flex items-center gap-1.5 rounded-pill border px-3.5 py-1.5 text-sm transition-colors', selected
            ? 'border-[color-mix(in_oklab,var(--color-accent)_60%,transparent)] bg-[var(--color-accent-soft)] text-[var(--color-accent-bright)]'
            : 'border-[var(--color-line-2)] bg-transparent text-[var(--color-ink)] hover:border-[var(--color-line-strong)] hover:bg-[var(--color-surface)]', className), children: children }));
});
